const discover = {
  "discover.page_title": "Jelajahi Deﬁne®",

  "discover.trait_01.title": "Teknologi <em>Beauty Wrapped In Comfort™ </em>",
  "discover.trait_01.body": "Pigmen diposisikan dengan aman di dalam lapisan material lensa, sehingga tidak bersentuhan dengan mata.",
  "discover.trait_02.title": "<em>Percaya diri dan terlindung</em> dari UV sepanjang hari*",
  "discover.trait_02.body": "Tetap aman dari radiasi UV berbahaya dengan tingkat perlindungan UV tertinggi dalam lensa kontak harian sekali pakai^.",
  "discover.trait_03.title": "<em>Proses</em> cetak berlapis",
  "discover.trait_03.body": "Paduan harmonis 3 lapisan transparan berpola organik yang dibuat untuk menegaskan, menonjolkan, dan menyatu alami dengan iris mata.",



  "discover.trait_04.title": "Dirancang untuk kenyamanan seharian",
  "discover.trait_04.item_01.title": "Desain tepi",
  "discover.trait_04.item_01.body": "Proﬁl tepi yang tipis dan menyatu dengan permukaan mata untuk mengurangi iritasi pada kelopak mata saat berkedip.",
  "discover.trait_04.item_02.title": "Kelembapan**",
  "discover.trait_04.item_02.body": "Teknologi yang didesain untuk membantu lapisan air mata mengurangi kekeringan.",
  "discover.trait_04.item_03.title": "Modulus",
  "discover.trait_04.item_03.body": "Lensa dengan modulus rendah yang lentur dan melekat pas di mata sehingga lebih nyaman bagi kornea dan kelopak mata.",
}

export const product_range = {
  "product_range.block_title": "Temukan <span>ACUVUE® Define®</span> yang sesuai untuk kamu",
  "product_range.button.classic": "Jelajahi Deﬁne® Classic",
  "product_range.button.fresh": "Jelajahi Deﬁne® Fresh",
}

export const try_lenses = {
  "try_lenses.block_title": "Coba lensa kontak <span>ACUVUE® Define® </span> secara virtual",
  "try_lenses.virtual_mirror": "Cermin Virtual",
}

const discover_references = {
  "discover_references": "<h1>*Membantu melindungi terhadap transmisi radiasi sinar UV berbahaya ke kornea dan mata.</h1> <p>^Peringatan: Lensa kontak dengan perlindungan dari sinar UV BUKAN pengganti kacamata pelindung UV seperti kacamata hitam anti sinar UV karena tidak sepenuhnya menutupi mata dan area sekitarnya. Anda harus tetap menggunakan kacamata pelindung UV sesuai petunjuk. CATATAN: paparan radiasi sinar UV jangka panjang adalah salah satu faktor risiko yang terkait dengan katarak. Paparan didasarkan pada sejumlah faktor seperti kondisi lingkungan (ketinggian, geograﬁs, tutupan awan) dan faktor pribadi (tingkat dan aktivitas di luar ruangan). Lensa kontak dengan UV-blocking membantu memberikan perlindungan terhadap radiasi UV yang berbahaya. Namun, studi klinis belum dilakukan untuk menunjukkan bahwa memakai lensa kontak UV-blocking mengurangi risiko terkena katarak atau gangguan mata lainnya. Konsultasikan dengan dokter mata Anda untuk informasi lebih lanjut.</p> <p>**Teknologi LACREON® adalah nama merek Johnson & Johnson Vision Care, Inc. untuk teknologi kepemilikan yang secara permanen menanamkan bahan pengikat air seperti dengan yang ditemukan pada air mata alami, ke dalam bahan etaﬁlcon A.</p> <p>Informasi penting untuk pengguna lensa kontak: Merek Lensa Kontak ACUVUE® hanya tersedia dengan resep dokter untuk koreksi penglihatan. Dokter mata akan menentukan apakah lensa kontak cocok untuk Anda. Meskipun jarang terjadi, masalah mata serius dapat berkembang saat memakai lensa kontak. Untuk membantu menghindari masalah ini, ikuti jadwal pemakaian dan penggantian serta instruksi perawatan lensa yang diberikan oleh dokter mata Anda. Jangan memakai lensa kontak jika Anda mengalami infeksi mata, atau mengalami ketidaknyamanan mata, robekan berlebihan, perubahan penglihatan, kemerahan, atau masalah mata lainnya. Jika salah satu dari kondisi ini terjadi, segera hubungi dokter mata Anda. Untuk informasi lebih lanjut tentang penggunaan, perawatan, dan keamanan yang tepat, bicarakan dengan Dokter Mata Anda atau lihat Panduan Instruksi Pasien ACUVUE®.</p>"
}


// export default discover;
export default {
  ...discover,
  ...try_lenses,
  ...product_range,
  ...discover_references
}







